import React, { ReactNode, useState, ReactElement } from 'react';

export type toggleSidebarFunction = () => void;
export const SideBarOpenedContext = React.createContext<[boolean, toggleSidebarFunction] | null[]>([null, null]);

interface ISideBarOpenedProviderProps {
  children: ReactNode
}

export const SideBarOpenedProvider = ({ children }: ISideBarOpenedProviderProps): ReactElement => {
  const [sideBarOpened, setSideBarOpened] = useState(false);

  const toggleSidebar = () => {
    setSideBarOpened(sideBarOpened => !sideBarOpened);
  };

  return (
    <SideBarOpenedContext.Provider value={[sideBarOpened, toggleSidebar]}>
      {children}
    </SideBarOpenedContext.Provider>
  );
};
